module.exports = __webpack_public_path__ + "img/648coupon.bdb92f4c.png";